import { StyledFooterDisclaimer } from './elements';

type Props = {
  children: React.ReactNode;
};

export const FooterDisclaimer = ({ children }: Props) => (
  <StyledFooterDisclaimer>{children}</StyledFooterDisclaimer>
);
